import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InvoiceRuleService {

  constructor() { }

  canGenerateInvoice(product: any): boolean {
    if (!product) {
      return false;
    }

    const moving = (product.orderMovingStatus || '').toUpperCase();

    if (product.status === 90 || moving === 'CAN') {
      return false;
    }

    return product.status === 20 && moving === 'INV';
  }

  canViewOrderConfirmation(product: any): boolean {
    if (!product) {
      return false;
    }

    const moving = (product.orderMovingStatus || '').toUpperCase();

    if (product.status === 90 || moving === 'CAN') {
      return false;
    }

    return product.status === 20 && moving === 'WIP';
  }

  getInvoiceTooltip(product: any): string {
    if (!product) {
      return 'Invoice cannot be generated for this order state';
    }

    const status = product.status;
    const moving = (product.orderMovingStatus || '').toUpperCase();

    if (status === 10 && (moving === 'CRT' || moving === 'PKL')) {
      return 'Order is not synced yet';
    }
    if (status === 15 && moving === 'WIP') {
      return 'Error while syncing';
    }
    if (status === 20 && moving === 'WIP') {
      return 'View order confirmation';
    }
    if (status === 20 && moving === 'INV') {
      return '';
    }
    if (status === 9 && (moving === 'CRT' || moving === 'PKL')) {
      return 'Order is on hold';
    }
    if (status === 90 && moving === 'CAN') {
      return 'Cannot generate invoice for cancelled order';
    }

    return 'Invoice cannot be generated for this order state';
  }
}